import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import './FeaturesSection.css';

const features = [
  {
    id: 0,
    title: 'Easy to Use',
    icon: '/hand.png', // update with your actual icon paths
    description: <span><strong>Hands-free dispensing</strong> gives you just the right amount. Tap your card and get exactly what you need.</span>,
    popupClass: 'popup-position-1'
  },
  {
    id: 1,
    title: 'Convenient Access',
    icon: '/pool.png',
    description: <span><strong>Fits standard poles</strong> and placed where you need them most.</span>,
    popupClass: 'popup-position-2'
  },
  {
    id: 2,
    title: 'High-Quality Formula',
    icon: '/quality.png',
    description: <span><strong>30 SPF protection</strong> that's gentle on skin and safe for reefs.</span>,
    popupClass: 'popup-position-3'
  },
  {
    id: 3,
    title: 'Clean and Maintained',
    icon: '/clean.png',
    description: <span><strong>Regularly cleaned</strong> to keep it hygienic and working well.</span>,
    popupClass: 'popup-position-4'
  },
  {
    id: 4,
    title: 'Sustainable Design',
    icon: '/sustainable.png',
    description: <span><strong>Solar powered</strong> and reduces plastic waste by eliminating single-use bottles.</span>,
    popupClass: 'popup-position-5'
  }
];

const FeaturesSection = () => {
  const navigate = useNavigate();
  const publicUrl = process.env.PUBLIC_URL || '';
  const [activeFeature, setActiveFeature] = useState(null);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 991);

  // Add resize listener for mobile detection
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 991);
    };
    
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const toggleFeature = (id) => {
    if (activeFeature === id) {
      setActiveFeature(null); // Close if clicking the same feature
    } else {
      setActiveFeature(id); // Open the clicked feature
    }
  };

  return (
    <div className="features-section full-width">
      <div className="features-content wider-content">
        {/* Tagline Section - Now with updated gold color and increased spacing */}
        <span className="features-label" style={{ color: '#1C3D49', marginBottom: '1rem' }}>Clean, Reliable and Approachable</span>
        <h1 className="features-headline" style={{ marginBottom: '1.5rem' }}><strong><span style={{ color: '#FBB040' }}>Sun Blocks</span></strong></h1>
        <p className="features-description" style={{ marginTop: '1.5rem' }}>
          <strong>Smart, solar-powered sunscreen dispensers</strong> designed for outdoor venues. Our innovative technology delivers high-quality sun protection on demand, reducing plastic waste while enhancing guest experience.
        </p>
        
        {isMobile ? (
          /* Mobile Layout: Stacked, accordion-style approach */
          <div className="features-mobile-container">
            <img 
              src={`${publicUrl}/enclosure_3.png`} 
              alt="Sun Blocks Device" 
              className="mobile-device-image"
            />
            
            <div className="mobile-features-list">
              {features.map((feature) => (
                <div 
                  key={feature.id}
                  className={`mobile-feature-item ${activeFeature === feature.id ? 'active' : ''}`}
                  onClick={() => toggleFeature(feature.id)}
                >
                  <div className="mobile-feature-header">
                    <img src={`${publicUrl}${feature.icon}`} alt={feature.title} />
                    <h3>{feature.title}</h3>
                    <span className="mobile-toggle-icon">
                      {activeFeature === feature.id ? '−' : '+'}
                    </span>
                  </div>
                  
                  {activeFeature === feature.id && (
                    <div className="mobile-feature-content">
                      <p>{feature.description}</p>
                    </div>
                  )}
                </div>
              ))}
            </div>
          </div>
        ) : (
          /* Desktop Layout: Interactive sidebar and display */
          <div className="features-interactive-container">
            {/* Sidebar with key points */}
            <div className="features-sidebar">
              <p className="features-click-hint">click to learn more</p>
              <ul>
                {features.map((feature) => (
                  <li 
                    key={feature.id} 
                    onClick={() => toggleFeature(feature.id)}
                    className={activeFeature === feature.id ? 'active' : ''}
                  >
                    <img src={`${publicUrl}${feature.icon}`} alt={feature.title} />
                    <span>{feature.title}</span>
                  </li>
                ))}
              </ul>
            </div>

            {/* Display area with central image and popup */}
            <div className="features-display">
              <div className="features-image">
                <img src={`${publicUrl}/enclosure_3.png`} alt="Central Device" />
                {activeFeature !== null && (
                  <div className={`feature-popup ${features[activeFeature].popupClass}`}>
                    <h4>{features[activeFeature].title}</h4>
                    <p>{features[activeFeature].description}</p>
                  </div>
                )}
              </div>
            </div>
          </div>
        )}
        
        {/* Button moved to bottom of the page with updated text */}
        <button 
          className="features-product-button"
          onClick={() => navigate('/product')}
        >
          Learn more
        </button>
      </div>
    </div>
  );
};

export default FeaturesSection; 